<template>
  <div>
    <div class="header pb-6 d-flex align-items-center profile-header">
      <!-- Mask -->
      <span class="mask bg-gradient-orange opacity-8"></span>
      <!-- Header container -->
      <b-container fluid class="align-items-center">
        <b-row>
          <b-col lg="7" md="10">
            <h1 class="display-2 text-white mt-5">
              <span v-if="user.firstName">Hello, {{ user.firstName }}</span>
              <span v-else>Hello, there</span>
            </h1>
            <p
              class="text-white mt-0 mb-5"
            >Member since {{ user.createdAt | moment('MMMM Do YYYY') }}</p>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="4" class="order-xl-2">
          <card>
            <h5 slot="header" class="h3 mb-0">Login details</h5>
            <h6 class="heading-small text-muted mb-4">
              <span class="mr-2">Email address</span>
              <b-badge
                v-if="user.email.isVerified"
                variant="success"
                style="vertical-align: text-bottom"
                title="Email address verified"
                v-b-tooltip.hover
              >
                <i class="fa fa-check"></i>
              </b-badge>
              <b-badge
                v-else
                variant="warning"
                style="vertical-align: text-bottom; cursor: pointer"
                @click="resendEmailVerification"
              >
                <i class="fa fa-exclamation-triangle mr-2"></i>Verify now
              </b-badge>
            </h6>
            <edit-email-address-form
              :emailAddress="user.email.address"
              @update-email="emailUpdated"
            ></edit-email-address-form>

            <hr class="my-4" />

            <h6 class="heading-small text-muted mb-4">Password</h6>
            <edit-password-form v-if="showUpdatePasswordForm" @updated-password="passwordUpdated"></edit-password-form>

            <div v-else>
              <base-input type="password" value="dummypassword" disabled></base-input>
              <b-button
                block
                variant="secondary"
                @click="showUpdatePasswordForm = true"
              >Change password</b-button>
            </div>
          </card>
        </b-col>
        <b-col xl="8" class="order-xl-1">
          <edit-profile-form></edit-profile-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import EditProfileForm from "./UserProfile/EditProfileForm.vue";
import EditEmailAddressForm from "./UserProfile/EditEmailAddressForm";
import EditPasswordForm from "./UserProfile/EditPasswordForm";
import UserCard from "./UserProfile/UserCard.vue";
import ProgressTrackList from "@/views/Dashboard/ProgressTrackList";

export default {
  components: {
    EditProfileForm,
    EditEmailAddressForm,
    EditPasswordForm,
    UserCard,
    ProgressTrackList,
  },
  data: function () {
    return {
      showUpdatePasswordForm: false,
    };
  },
  computed: {
    user() {
      return this.$auth.user();
    },
  },
  methods: {
    emailUpdated: function (val) {
      this.$auth.user().email = val;
    },
    passwordUpdated: function (val) {
      this.showUpdatePasswordForm = false;
    },
    resendEmailVerification: function () {
      this.axios
        .put(`/v1/users/me/email`, { address: this.$auth.user().email.address })
        .then((response) => {
          if (response.data && response.data.address) {
            this.$notify({
              message: "Please check your email inbox",
              timeout: 2000,
              icon: "fa fa-paper-plane",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          }
          return response;
        })
        .catch((error) => {
          let errorMessage = "Error sending email address verification email";
          this.$notify({
            message: errorMessage,
            timeout: 2000,
            icon: "fa fa-exclamation-triangle",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        });
    },
  },
};
</script>
<style>
.profile-header {
  background-size: cover;
  background-position: center top;
  min-height: 200px;
}
</style>
